module.exports = __webpack_public_path__ + "static/hormel-small-7617c63ce418de2c60e67f1c6219c581.png";